// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import About from './pages/About';
import Features from './pages/Features';
import HomePage from './pages/HomePage';
import Resources from './pages/Resources'
import Toolkit from './pages/Toolkit';
import VendorReview from './pages/VendorReview';
import Footer from './components/Footer';
import Insights from './pages/Insights';
import Thiyapedia from './pages/Thiyapedia';
import Blog from './pages/Blog';
import Article from './pages/Article';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/Thhiyapedia" element={<Thiyapedia />} />
        <Route path="/resources/Blogs" element={<Blog />} />
        <Route path="/resources/Articles" element={<Article />} />
        <Route path="/vendor-review" element={<VendorReview />} />
        <Route path="/gtm-toolkit" element={<Toolkit />} />
        <Route path="/insights" element={<Insights />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
